const appThemeKey = 'app-theme';

const defaultViewType = 'single-view';

const helixActivePanelsKey = 'helix-active-panels';

export { appThemeKey, defaultViewType, helixActivePanelsKey };
